import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fa13713"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fm-audio-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "fm-info-wrap" }
const _hoisted_4 = { class: "fm-base-info" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "fm-play-count" }
const _hoisted_7 = { class: "fm-slider-wrap" }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "slider-wrap" }
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { class: "fm-slider-control" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://h5.luosijiaoyu.com/old/#/propaganda" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "iconfont iconxiayishoubeifen" })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://h5.luosijiaoyu.com/old/#/propaganda" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "iconfont iconxiayishou" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_slider = _resolveComponent("van-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "fm-cover-img",
      src: _ctx.audioDetail.coverFileUrl
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "fm-title",
          textContent: _toDisplayString(_ctx.audioDetail.title1)
        }, null, 8, _hoisted_5),
        _createElementVNode("div", _hoisted_6, _toDisplayString(1 > _ctx.audioDetail.visitNum / 10000
              ? "1.0"
              : (_ctx.audioDetail.visitNum / 10000).toFixed(1)) + "万次播放 ", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: "player-time",
        textContent: _toDisplayString(_ctx.audioCurrentTime)
      }, null, 8, _hoisted_8),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_van_slider, {
          modelValue: _ctx.audioChildCurrentSlider,
          "onUpdate:modelValue": _ctx.changeAudioChildCurrentSlider,
          onChange: _ctx.sliderChange,
          "bar-height": "4px",
          "button-size": "10px",
          "active-color": "#FB6E74",
          "inactive-color": "#E6E6E6"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
      ]),
      _createElementVNode("div", {
        class: "player-time",
        textContent: _toDisplayString(_ctx.audioDuration)
      }, null, 8, _hoisted_10)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", {
        class: _normalizeClass(['iconfont', _ctx.isPaused ? 'iconzanting' : 'iconkaishi']),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changePlayStatus && _ctx.changePlayStatus(...args)))
      }, null, 2),
      _hoisted_13
    ])
  ]))
}